
import { mapGetters } from 'vuex'

export default {
  name: 'Glossary',
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$i18n.t('seo.glossary.title'),
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$i18n.t('seo.glossary.description')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('seo.glossary.keyWords')
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.$i18n.t('seo.glossary.title')
        },
        {
          property: 'og:url',
          content: 'https://' + this.$i18n.localeProperties.domain + this.$route.fullPath
        },
        {
          property: 'og:description',
          content: this.$i18n.t('seo.glossary.description')
        },
        {
          property: 'twitter:card',
          content: 'summary'
        },
        {
          property: 'twitter:site',
          content: '@Enerdata'
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('seo.glossary.title')
        },
        {
          property: 'twitter:description',
          content: this.$i18n.t('seo.glossary.description')
        },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    ...mapGetters({
      pages: 'pages'
    }),
    pageLandscapeImage () {
      return require('../assets/images/jumbotron/homepage.jpg')
    },
    glossary () {
      let glossary = []
      glossary = this.pages.filter(page => page.jumbotron !== 'country-snapshot').map(elem => (
        {
          title: elem.title,
          text: elem.glossary
        }
      ))
      // glossary.filter((a, b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0))
      return glossary
    }
  }
}
